import { render, staticRenderFns } from "./modifypwd.vue?vue&type=template&id=6f67ee68&scoped=true&"
import script from "./modifypwd.vue?vue&type=script&lang=js&"
export * from "./modifypwd.vue?vue&type=script&lang=js&"
import style0 from "./modifypwd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./modifypwd.vue?vue&type=style&index=1&id=6f67ee68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67ee68",
  null
  
)

export default component.exports